import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Alert from 'react-bootstrap/lib/Alert';
import { reportMessage } from 'redux/modules/reports';

@connect(
  (state) => ({
    sendingMessageReport: state.reports.sendingMessageReport,
    sentMessageReport: state.reports.sentMessageReport,
  }),
  {
    reportMessage,
  }
)
export default class ReportMessages extends Component {
  static propTypes = {
    reportMessage: PropTypes.func,
    match: PropTypes.object,
    sendingMessageReport: PropTypes.bool,
    sentMessageReport: PropTypes.bool,
  };

  constructor() {
    super();

    this.state = {
      error: false,
    };
  }

  UNSAFE_componentWillMount() {
    if (+this.props.match.params.messageId) {
      this.setState({
        error: true,
      });
    } else {
      this.props.reportMessage(this.props.match.params.messageId);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.sendingMessageReport &&
      !nextProps.sendingMessageReport &&
      !nextProps.sentMessageReport
    ) {
      this.setState(
        {
          error: true,
        },
        function () {
          setTimeout(() => {
            document.location = '/messages';
          }, 3000);
        }
      );
    }

    if (!this.props.sentMessageReport && nextProps.sentMessageReport) {
      setTimeout(() => {
        document.location = '/messages';
      }, 3000);
    }
  }

  render() {
    const { error } = this.state;
    const { sentMessageReport } = this.props;

    return (
      <div className="container mt++">
        <Alert
          bsStyle={error ? 'danger' : sentMessageReport ? 'success' : 'info'}
          className="text-center"
        >
          {error
            ? 'Sorry there was an error processing your request'
            : sentMessageReport
            ? 'Thanks for letting us know, the message has been reported.'
            : 'Sending report...'}
        </Alert>
      </div>
    );
  }
}
